import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCommits: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"commits"} maskId="square-filled-radius-0-stroke-1-IconCommits"><path d="M12 6C15.1453 6 17.7234 8.42031 17.9775 11.5H23V12.5H17.9775C17.7234 15.5797 15.1453 18 12 18C8.85472 18 6.27661 15.5797 6.02246 12.5H1V11.5H6.02246C6.27661 8.42031 8.85472 6 12 6Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconCommits;
